module.exports = __webpack_public_path__ + "img/img7.832fb632.png";